import React from "react";
import "./ProviderList.scss";
import TitleGroup from "@atoms/TitleGroup/TitleGroup";
import CardSlider from "@components/CardSlider/CardSlider";
import Section from "@atoms/Section/Section";
import { SwiperSlide } from "swiper/react";
import Module from "@atoms/Module/Module";
import Text from "@atoms/Text/Text";
import Title from "@atoms/Title/Title";
import Avatar from "@components/Avatar/Avatar";
import Badge from "@atoms/Badge/Badge";
import CommonActionButton from "./CommonActionButton";

const ProviderList = ({
	theme,
	title,
	subtitle,
	providerList,
	extraCard,
	variant = "short",
}) => {
	const getBadgeColor = (color: string) => {
		switch (color) {
			case "red":
				return "error-3";
			case "green":
				return "positive";
			case "blue":
			default:
				return "info";
		}
	};
	if (!providerList) return <></>;
	return (
		<>
			<Section container="large" spacing="m" className="ProviderList">
				<TitleGroup
					align="left"
					title={title}
					subtitle={subtitle}
					theme={theme}
				/>
				<CardSlider
					sliderName="ProviderList"
					hasNavigation
					hideOverflow
					sliderOption={{
						slidesPerView: 1.1,
						preventClicks: true,
						a11y: false,
						preventClicksPropagation: true,
						threshold: 20,
						breakpoints: {
							slidesOffsetAfter: 20,
							slidesOffsetBefore: 20,
							501: {
								slidesPerView: 1.3,
								spaceBetween: 16,
							},
							801: {
								slidesPerView: 2.3,
								spaceBetween: 16,
							},
							1001: {
								slidesPerView: 3.3,
							},
						},
					}}
				>
					{providerList.map((item: any, index: number) => {
						return (
							<SwiperSlide key={`ProviderList--item${index}`}>
								<Module radius="xl" padding="m">
									<div>
										<Avatar
											align="center"
											src={item.avatar?.src?.url}
											size="m"
											audioSrc={item.audio?.url}
											urlSharp={item.avatar?.src?.urlSharp}
											alt={item.name}
											mediaUrl={item?.media?.url}
										/>

										<Section spacingTop="s" spacingBottom="xs">
											<Badge
												variant={getBadgeColor(item.badgeColor)}
												align="center"
												size="s"
												className="ProviderList--badge"
											>
												{item.badgeLabel}
											</Badge>
										</Section>
										{item.quote && (
											<>
												{variant === "short" ? (
													<Title
														size="ml"
														align="center"
														font="alt"
														className="ProviderList--quote"
													>
														"{item.quote}"
													</Title>
												) : (
													<Section spacingBottom="xs">
														<Text
															size="s"
															align="center"
															className="ProviderList--quote"
														>
															"{item.quote}"
														</Text>
													</Section>
												)}
											</>
										)}
									</div>

									<div>
										<Text size="s" align="center">
											{item.name}
										</Text>
										{item.yearsOfExp && (
											<Text size="s" align="center">
												{item.yearsOfExp}
											</Text>
										)}
									</div>
								</Module>
							</SwiperSlide>
						);
					})}
					{extraCard && (
						<SwiperSlide>
							<Module radius="xl" padding="m" className="ActionCard">
								<Section spacingTop="s">
									<Title
										size="xl"
										theme="white"
										align="left"
										font="alt"
										className="ActionCard--title"
									>
										{extraCard.title}
									</Title>
								</Section>
								<Section spacingBottom="s">
									<CommonActionButton
										cta={{
											ctaLabel: extraCard.ctaLabel,
											ctaUrl: extraCard.ctaUrl,
											ctaProps: {
												theme: "white",
												isMobileFullsize: true,
												className: "ActionCard--cta",
												size: "l",
												align: "left",
											},
											ctaAnchorLink: extraCard.ctaAnchorLink,
										}}
									/>
								</Section>
							</Module>
						</SwiperSlide>
					)}
				</CardSlider>
			</Section>
		</>
	);
};

export default ProviderList;
